<h2 color="primary">パスワードを変更してください</h2>
@if (showSpinner) {
  <div class="spinner">
    <mat-spinner diameter="60"></mat-spinner>
  </div>
}
@if (changeForm) {
  <div class="login-container">
    <form [formGroup]="changeForm" (ngSubmit)="onSubmit(changeForm.value)" autocomplete="on">
      <div class="category-container">
        <div>
          <label>新パスワード</label>
          <mat-hint>　{{ Constant.msgPassInvalid }}</mat-hint>
        </div>
        <div>
          <input class="text-input" type="password" formControlName="newPassword" required
          [class.input-invalid]="changeForm.get('newPassword')?.invalid && (changeForm.get('newPassword')?.touched || changeForm.get('newPassword')?.dirty)"/>
        </div>
        <div class="password-error">
          @if (changeForm.get('newPassword')?.invalid && (changeForm.get('newPassword')?.touched || changeForm.get('newPassword')?.dirty)) {
            <mat-error class="error-text">
              英字と数字の組み合わせ、8桁以上で入力してください。
            </mat-error>
          }
        </div>
      </div>
      <div class="category-container">
        <div>
          <label>新パスワード（確認）</label>
        </div>
        <div>
          <input class="text-input" type="password" formControlName="newPasswordConfirm" required />
        </div>
        <div class="password-error">
          @if (newPasswordConfirm.invalid && newPasswordConfirm.touched) {
            <mat-error class="error-text">
              パスワード（確認）を入力してください。
            </mat-error>
          }
        </div>
        <div class="password-error">
          @if (newPasswordConfirm.dirty && changeForm.errors) {
            <mat-error class="error-text">
              パスワードとパスワード（確認）が異なります。
            </mat-error>
          }
        </div>
    </div>
      <div class="footer-container">
        <button mat-raised-button class="change-button" type="submit" [disabled]="!changeForm.valid">
          パスワード変更
        </button>
      </div>
      <div class="attention">
        UNION NESTの<a (click)="onAgreement()">利用規約</a>および<a (click)="onPrivacy()">プライバシーポリシー</a>に同意のうえ、<br>
          「パスワード変更」を押してください。
        </div>
      </form>
    </div>
  }
